import Vue from "vue";
import VMask from "v-mask";

Vue.use(VMask);
